const ITEM_CARD_LIST_SEQUENCE_HEADER_TITLE = "Chronological List";
const ITEM_CARD_LIST_NARRATIVE_HEADER_TITLE = "Narrative Outline";

export { ITEM_CARD_LIST_NARRATIVE_HEADER_TITLE, ITEM_CARD_LIST_SEQUENCE_HEADER_TITLE };
